module.exports = __webpack_public_path__ + "static/media/camera.3a157328.png";